import util from '@bmp-vue/core/api/util'

const controller = 'ContaCorrentistas'

export default Object.assign({}, util.GetCrud(controller, null), {
  AlterarTitularPrincipal: function (id) {
    return util.Axios.Put(controller + '/AlterarTitularPrincipal', id)
  }
})
